import HttpClient from '@/common/boot/HttpClient';

const obterResumoHeaderBacklog = async ({ commit }, payload = {}) => {
  commit('LOADING', true)
  try {
    const response = await HttpClient.get('/painel-backlog/header', { params: payload })
    const dados = response?.data?.data

    commit('INSERE_BACKLOG_HEADER_BACKLOG', dados)
    if (dados && Array.isArray(dados.itens)) {
      commit('INSERE_BACKLOG_TAREFAS', dados)
    }
    return dados
  } finally {
    commit('LOADING', false)
  }
}

const obterDetalhesProcessoBacklog = async (
  { commit },
  { ctrlProcessoId, ...payload } = {}
) => {
  if (ctrlProcessoId == null || ctrlProcessoId === '') {
    commit('LIMPAR_DETALHES_PROCESSO_BACKLOG')
    return null
  }

  commit('LOADING_DETALHES_PROCESSO_BACKLOG', true)

  try {
    const response = await HttpClient.get(
      `/painel-backlog/processos/${Number(ctrlProcessoId)}/tarefas`,
      { params: payload }
    )

    const dados = response?.data?.data ?? null
    commit('INSERE_DETALHES_PROCESSO_BACKLOG', dados)
    return dados
  } finally {
    commit('LOADING_DETALHES_PROCESSO_BACKLOG', false)
  }
}

const limparDetalhesProcessoBacklog = ({ commit }) => {
  commit('LIMPAR_DETALHES_PROCESSO_BACKLOG')
}

const listarFiltrosPainelBacklog = async ({ commit }) => {
  const response = await HttpClient.get('/painel-backlog/filtros')
  commit('INSERE_FILTROS_PAINEL_BACKLOG', response?.data?.data || {})
}

export {
  obterResumoHeaderBacklog,
  obterDetalhesProcessoBacklog,
  limparDetalhesProcessoBacklog,
  listarFiltrosPainelBacklog,
}